const INSTALL_ID_KEY = 'layers_install_id';

let asyncStorageInstance: any | null = null;
let asyncStorageLoadPromise: Promise<any | null> | null = null;

let _pendingPromise: Promise<string> | null = null;

async function getAsyncStorage() {
  if (asyncStorageInstance) {
    return asyncStorageInstance;
  }

  if (!asyncStorageLoadPromise) {
    asyncStorageLoadPromise = import('@react-native-async-storage/async-storage')
      .then((mod) => {
        asyncStorageInstance = mod.default ?? mod;
        return asyncStorageInstance;
      })
      .catch(() => null);
  }

  return asyncStorageLoadPromise;
}

export function getOrSetInstallId(): Promise<string> {
  if (_pendingPromise) {
    return _pendingPromise;
  }

  _pendingPromise = (async () => {
    try {
      const AsyncStorage = await getAsyncStorage();

      if (!AsyncStorage) {
        console.warn(
          '[Layers] AsyncStorage not found. Using temporary install_id. Identity will not persist across restarts.'
        );
        return generateUUID();
      }

      // 1. Try to get existing ID
      const existingId = await AsyncStorage.getItem(INSTALL_ID_KEY);
      if (existingId) {
        return existingId;
      }

      // 2. Generate new ID (UUID v4 format)
      const newId = generateUUID();

      // 3. Save it
      await AsyncStorage.setItem(INSTALL_ID_KEY, newId);

      return newId;
    } catch (error) {
      // Fallback if storage fails
      console.warn('[Layers] Failed to access storage for install_id', error);
      return generateUUID();
    }
  })();

  return _pendingPromise;
}

function generateUUID(): string {
  // Simple UUID v4 generator compliant with RFC 4122
  // eslint-disable-next-line no-bitwise
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
